export const spaceshipRecordListOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  searchShow: false,
  searchBtn: false,
  refreshBtn: false,
  columnBtn: false,
  menu: false,
  addBtn: false,
  delBtn: false,
  editBtn: false,
  viewBtn: false,
  searchBtn: false,
  column: [
    {
      label: '区域',
      prop: 'regionName',
      editDisabled: true,
    },
    {
      label: '市场',
      prop: 'marketName',
      editDisabled: true,
    },
    {
      label: '总经理',
      prop: 'gmName',
      editDisabled: true,
      width: '120px',
    },
    {
      label: '营运总监',
      prop: 'doName',
      editDisabled: true,
      width: '120px',
    },
    {
      label: '营运经理',
      prop: 'omName',
      editDisabled: true,
      width: '120px',
    },
    {
      label: '营运顾问',
      prop: 'ocName',
      editDisabled: true,
      width: '120px',
    },
    {
      label: '餐厅国际编号',
      prop: 'storeCode',
      editDisabled: true,
      width: '120px',
    },
    {
      label: '餐厅名称',
      prop: 'storeName',
      editDisabled: true,
      width: '200px',
    },
    {
      label: '员工编号',
      prop: 'unionId',
      editDisabled: true,
      width: '120px',
    },
    {
      label: '员工姓名',
      prop: 'nickName',
      editDisabled: true,
      width: '130px',
    },
    {
      label: '身份',
      prop: 'identity',
      editDisabled: true,
    },
    {
      label: '职位',
      prop: 'position',
      width: '200px',
      editDisabled: true,
    },
    {
      label: '助力状态',
      prop: 'hasBoosted',
      editDisabled: true,
    },
  ]
}